import { render } from "./SelectMaritalStatus.vue?vue&type=template&id=71410770&ts=true"
import script from "./SelectMaritalStatus.vue?vue&type=script&lang=ts"
export * from "./SelectMaritalStatus.vue?vue&type=script&lang=ts"

import "./SelectMaritalStatus.vue?vue&type=style&index=0&id=71410770&lang=scss"

import exportComponent from "/home/uatcomp/public_html/wizards/travel-insurance-wizard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__